import { inputLabelClasses } from '@mui/material/InputLabel';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { Components, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

const disableSpinButtonStyle = {
  '-webkit-appearance': 'none',
  margin: 0
};

export const muiTextFieldOverride: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  defaultProps: {
    sx: {
      fontSize: '0.875rem',
      '& .MuiInputBase-input.Mui-disabled': {
        WebkitTextFillColor: colors.text[60]
      }
    },
    InputLabelProps: {
      style: {
        fontSize: '0.875rem'
      }
    }
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      'input[type=number]::-webkit-outer-spin-button': disableSpinButtonStyle,
      'input[type=number]::-webkit-inner-spin-button': disableSpinButtonStyle,
      '& .MuiFilledInput-root': {
        '&:hover fieldset': {
          borderColor: colors.primary[80]
        }
      },
      '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
          borderColor: colors.primary[80]
        }
      },
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: colors.primary[80]
      },
      [`.${inputLabelClasses.focused}`]: {
        maxWidth: '100%'
      },
      [`.${inputLabelClasses.root}`]: {
        maxWidth: 'calc(100% - 40px)'
      },
      [`.${outlinedInputClasses.notchedOutline}`]: {
        borderColor: colors.text[80]
      }
    })
  }
};
